import { render, staticRenderFns } from "./ReqCompraTableComponent.vue?vue&type=template&id=1a178e0d&"
import script from "./ReqCompraTableComponent.vue?vue&type=script&lang=js&"
export * from "./ReqCompraTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports